var app = angular
  .module('leonardo', [
    'angular-jwt',
    'ui.router',
    'angularUtils.directives.dirPagination',
    'ngFileUpload',
    'ngDialog',
    'ncy-angular-breadcrumb',
    'truncate',
    'restangular',
    'ngSanitize',
    'blockUI',
    'ngAnimate',
    'ngCsv',
    'ngCkeditor',
    'uiGmapgoogle-maps',
    'pascalprecht.translate',
    // 'builder',
    // 'builder.components',
    // 'validator.rules',
    'angular-clipboard',
    'angular-bind-html-compile',
    'filereader',
    'ngPrint',
    'signature',
    'ng.deviceDetector',
    'chart.js',
    'rzModule',
    'angular-timezone-selector',
    'colorpicker.module',
    'ui.router.state.events'
    ])
  .run(function ($rootScope, $state) {
    $rootScope.loadReact = function ({ selector, component, $element, data }) {
      const el = $element.find(selector)[0];
      if (!el) {
        console.log(`Not found selector ${selector} for react component`);
        return;
      }
      ReactDOM.render(React.createElement(component, data), el);
    };

    document.addEventListener('navigate', function (event) {
      const name = typeof event.detail.toState === 'object' ? event.detail.toState.name : event.detail.toState
      $state.go(name, event.detail.toParams, { inherit: false })
    })
  })
  .config(function myAppConfig(
    $locationProvider, $qProvider) {
      $locationProvider.html5Mode(false).hashPrefix('');
      $qProvider.errorOnUnhandledRejections(false);
  })

angular.module('leonardo').config([
  'uiGmapGoogleMapApiProvider',
  function (GoogleMapApiProviders) {
    GoogleMapApiProviders.configure({
      key: window.LEO_GMAPS_KEY,
      v: '3.20', //defaults to latest 3.X anyhow
      libraries: 'weather,geometry,visualization'
    });
  }
]);

var isNull = function (element) {
  if(angular.isNumber(element)){
    return isNaN(element);
  }
  return (element === undefined || element === null || element === '');
};

var isEmpty = function (element) {
  if (angular.isArray(element)) {
    return (element.length === 0);
  }
  return (angular.isObject(element) ? Object.entries(element).length === 0 : isNull(element));
};

var isEquals = function (obj1, obj2) {
  if (isNull(obj1) && isNull(obj2)) {
    return true;
  }
  return JSON.stringify(obj1) === JSON.stringify(obj2);
}

var isArray = function (object) {
  return angular.isArray(object);
};

var getIndexArray = function (array, id, key_id) {
  var index = -1;
  var array_id = key_id ? key_id : 'id';
  angular.forEach(array, function (element, key) {
    if (element[array_id] === id) {
      index = key;
    }
  });
  return index;
};

var formatDate = function (date) {
  var y = date.getFullYear(),
    m = date.getMonth() + 1,
    d = date.getDate();
  function z(i) {
    return i <= 9 ? '0' + i : i;
  }
  return y + '-' + z(m) + '-' + z(d);
};

var formatDateShow = function (date) {
  var y = date.getFullYear(),
    m = date.getMonth() + 1,
    d = date.getDate();
  function z(i) {
    return i <= 9 ? '0' + i : i;
  }
  return z(m) + '-' + z(d) + '-' + y;
};

var hexToRgb = function (hex) {
  var result = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(hex);
  return result
    ? {
        r: parseInt(result[1], 16),
        g: parseInt(result[2], 16),
        b: parseInt(result[3], 16)
      }
    : null;
};

var getExpDecimal = function (number) {
  var exp = Math.trunc(number / 10);
  var result = 1;
  while (exp > 0) {
    exp = Math.trunc(exp / 10);
    result++;
  }
  return result;
};

var capitalize = function (name) {
  return name.charAt(0).toUpperCase() + name.slice(1);
};
